export const TEST_ID = 'floatingResourceAddProvider';
